export const t_global_breakpoint_xl = {
  "name": "--pf-t--global--breakpoint--xl",
  "value": "75rem",
  "var": "var(--pf-t--global--breakpoint--xl)"
};
export default t_global_breakpoint_xl;